import React, { FC } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import InfoToolTip from '../../../../@shared/infoToolTip';
import { TMSRPRow } from '../../../types/index.types';
import formatText from './formatText';

const MSRPRow: FC<TMSRPRow> = (props) => {
  const { mrpRow, searchTerm, colOrdInIndex, showHiddenRightCells } = props;
  return (
    <tr>
      {!mrpRow.hideRow && (
        <>
          <td className="model-detail-specification-table__left-most-cell">
            <div
              className={`
                model-detail-specification-table__left-side-accordion-spec-title
                model-detail-specification-table__left-side-accordion-spec-title--border-hidden
                model-detail-specification-table__cell-animation
            `}
            >
              <>{mrpRow.label && <span>{formatText(mrpRow.label, searchTerm)}</span>}</>

              <InfoToolTip className="model-detail-specification-table__info-icon" showIcon={Boolean(mrpRow?.showTooltip)} width={300}>
                <div className="model-detail-specification-table__tooltip-wrapper">
                  {mrpRow.title && (
                    <Text field={mrpRow.title} tag="h2" className="model-detail-specification-table__tooltip-title" editable={false} />
                  )}
                  {mrpRow.description && (
                    <Text
                      field={mrpRow.description}
                      tag="div"
                      className="model-detail-specification-table__tooltip-body"
                      editable={false}
                    />
                  )}
                </div>
              </InfoToolTip>
            </div>
          </td>
          {mrpRow.prices
            ?.filter((_, columnIndex) => {
              if (!showHiddenRightCells) return columnIndex <= 5;
              return true;
            })
            .map((spec, specIndex) => (
              <td
                key={`model-detail-specification-table__spec-${spec}`}
                className={`
                  model-detail-specification-table__table-cell
                  model-detail-specification-table__table-cell--${specIndex % 2 === 0 ? 'even' : 'odd'}
                  model-detail-specification-table__table-cell--border-hidden
                `}
              >
                <div className="model-detail-specification-table__spec model-detail-specification-table__cell-animation">
                  {mrpRow.prices[colOrdInIndex[specIndex]]}
                </div>
              </td>
            ))}
        </>
      )}
    </tr>
  );
};

export default React.memo(MSRPRow);
